import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export type Company = Endpoints['GET /companies']['response']['companies'][number];
export type CompanyDetail = Endpoints['GET /companies/:id']['response'];
export type CompanyFromGetMany = Company;

export const useCompanies = (
  params?: Endpoints['GET /companies']['query'],
  options: {
    keepPreviousData?: boolean;
  } = {}
) => {
  const fetch = useFetch<Endpoints['GET /companies']>();

  return useQuery({
    queryKey: ['companies', params],
    queryFn: () => fetch('/companies', params),
    placeholderData: options?.keepPreviousData ? keepPreviousData : undefined,
  });
};

export const useCompany = (id: string | undefined) => {
  const fetch = useFetch<Endpoints['GET /companies/:id']>();

  return useQuery({
    queryKey: ['companies', id],
    queryFn: () => fetch(`/companies/${id}`),
    enabled: !!id,
  });
};

export const useUpdateCompany = (companyId: string | undefined) => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['PATCH /companies/:id']>();

  return useMutation({
    mutationFn: (body: Endpoints['PATCH /companies/:id']['body']) =>
      fetch(`/companies/${companyId}`, undefined, { method: 'PATCH', body }),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['companies'] }),
  });
};
